/**
 * The external dependencies.
 */

/**
 * Get currently set task view.
 *
 * @param  {Object}  state
 * @param  {Object}  state.taskView
 * @return {String}
 */
export const getTaskViewCurrent = ({taskView}) => taskView.view;



// WEBPACK FOOTER //
// ./src/store/task-view/selectors.js